import { useContext, useEffect, useReducer, useState } from "react";
import { Get } from "../Rutas/ApiRest";
import { cuentaCliente } from "../Rutas/Servicios";
import { Contexto } from "../Context/Contexto";
import { tokens } from "../Context/Tokens";
import PreAlerta from "./PreAlerta";
import { MensajeContActualizacion } from "../Context/MensajeContextActualizacion";

export default function PreAlertas()
{
    const url="<iframe src='https://eboxwidget.mbe-latam.com/@id' style='width:100%; height:800px; border:none;'></iframe>";
    const [Api,SetApi]=useState<string>("")
    const {Cli}=useContext(Contexto)
    const {tok}=useContext(tokens)
    const {SetActivoPreAlerta}=useContext(MensajeContActualizacion)
    const [state,dispatch]=useReducer(reducer,{nombre:"",apellido:"",email:"",confirmacionEmail:"",claves:"",confirmacionClave:"",fechaNacimiento:""})
    useEffect(()=>{
        if(Cli.lCasilla[Cli.Eleccion].ecode!="")
              {
                const dato3=Get(cuentaCliente.ApiZoom.replace("@ecode",Cli.lCasilla[Cli.Eleccion].ecode),"application/json",tok)
                dato3?.then(resultado=>{SetApi(resultado)})
              }
      },[Cli.Eleccion])

      useEffect(()=>{
        if(Cli.lCasilla[Cli.Eleccion].ecode!="")
              {
  
                const dato3=Get(cuentaCliente.ApiZoom.replace("@ecode",Cli.lCasilla[Cli.Eleccion].ecode),"application/json",tok)
                dato3?.then(resultado=>{SetApi(resultado)})
              }
              dispatch({type:"Reinicio"})
      },[Cli.lCasilla])

      function reducer(state:any,action:any)
    {
      switch(action.type)
      {
        
        case "cambio":return {
          ...state,[action.input.name]:action.input.value
        }
        case "Reinicio":
          {
            return {nombre:Cli.nombre,apellido:Cli.apellidoPaterno,email:Cli.email,confirmacionEmail:Cli.email,claves:"",confirmacionClave:""}
        }
          
         
      }
    
      return state;
    }

    return(
        <>

           <div className="fondo-blanco h-100">
          <div className="card">
          <div className="col-sm-12">

          <div className="card-body text-secondary px-sm-4" >
            <p className="subtitulo" >Pre Alerta – Envíos Parcializados</p>
            <p>
            Cuando tus productos sean enviados de forma parcializada (es decir, en varios paquetes con más de un número de tracking o rastreo), es <strong>FUNDAMENTAL</strong> que te comuniques con nuestro Servicio al Cliente una vez que lleguen a Miami, escribiendo a <a href="mailto:info@eshopex.cl">info@eshopex.cl</a> para así no pagar impuestos de más.
            </p>
            <p>
            No subas la factura por este medio (carga parcializada) ya que si no se informa correctamente este tipo de envío, los productos podrían ser declarados con valores incorrectos en Aduana, lo que puede generar un pago mayor de impuestos.
            </p>
            <p>
            Realizar este paso asegura una correcta gestión de tus paquetes y te ayuda a evitar sobrecostos innecesarios.
            </p>
            <p></p>
        </div>

          
        </div>
            <div className="card-body">
            
            
      
              <div className="accordion" id="accordionExample">
  <div className="accordion-item">
    <h2 className="accordion-header" id="headingOne">
      <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded={false} aria-controls="collapseOne" >
      PreAlerta U.S.A
      </button>
    </h2>
    <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
      <div className="accordion-body">

        {/* PreAlerta Miami Desactivado */}
      {/* <div className="row" dangerouslySetInnerHTML={{"__html":url.replace("@id",Api)}} ></div> */}

      <div className="container" style={{maxWidth:"720px"}}>
            <div className="row" >
              <div className="col-sm-12" style={{flex:"0 0 100%",maxWidth:"100%"}}>
              <div className="ecr-button-content mt-5" >
                    
                   
                 </div>
                 <hr className="mb-4"></hr>
                 <h3 style={{lineHeight:"1.2",boxSizing:"border-box",textAlign:"center"}}>Prealerta U.S.A no disponible momentáneamente</h3>
                 
              </div>
            </div>
            <div className="fondo-blanco h-100" style={{marginTop:"20px"}}>
                  <h6> Estamos realizando mejoras en la experiencia.<strong> Puedes seguir comprando y enviando tus productos con normalidad, ya que la prealerta es opcional y no afecta el proceso.</strong></h6>
                 </div>
        </div>
      </div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 className="accordion-header" id="headingTwo">
      <button className="accordion-button collapsed"  type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded={false} aria-controls="collapseTwo" >
        PreAlerta España
      </button>
    </h2>
    <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
      <div className="accordion-body">
        <div className="container" style={{maxWidth:"720px"}}>
            <div className="row" >
              <div className="col-sm-12" style={{flex:"0 0 100%",maxWidth:"100%"}}>
              <div className="ecr-button-content mt-5" >
                    <button  className="btn btn-success" style={{fontWeight:"400",textAlign:"center",display:"inline-block"}} onClick={()=>SetActivoPreAlerta(true)}> Nueva PreAlerta </button>
                   
                 </div>
                 <hr className="mb-4"></hr>
                 <h3 style={{lineHeight:"1.2",boxSizing:"border-box",textAlign:"center"}}>Historial PreAlertas España</h3>
                 
              </div>
            </div>
            <div className="fondo-blanco h-100" style={{marginTop:"20px"}}>
                   <PreAlerta></PreAlerta>
                 </div>
        </div>
      </div>
      
    </div>
  </div>
</div>
              </div>
              </div>
              </div>
        </>
    )
}